// extracted by mini-css-extract-plugin
export default {"last_update_at":"styles-module_last_update_at__7eVtk","lastUpdateAt":"styles-module_last_update_at__7eVtk"};